'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'medal';
var width = 512;
var height = 512;
var aliases = [127941];
var unicode = 'f5a2';
var svgPathData = 'M342.1 289.6L289.7 282l-23.5-47.5c-2-4.25-6.125-6.375-10.25-6.375S247.9 230.3 245.7 234.5L222.2 282l-52.37 7.625C160.5 291 156.6 302.6 163.5 309.3l37.87 37L192.5 398.5c-1.375 7.375 4.625 13.38 11.25 13.38c1.75 0 3.625-.375 5.375-1.375l46.87-24.62l46.87 24.62c1.75 1 3.625 1.375 5.375 1.375c6.625 0 12.62-6 11.25-13.5l-8.875-52.13l37.87-37C355.4 302.6 351.6 291 342.1 289.6zM256 144c-101.6 0-183.1 82.38-183.1 184S154.4 512 256 512s183.1-82.38 183.1-184S357.6 144 256 144zM256 464c-74.99 0-135.1-61.01-135.1-136S181 192 256 192s135.1 61.01 135.1 136S330.1 464 256 464zM135.9 148.5L68.84 48h69.22l44.13 77.22c15.49-5.641 31.73-9.672 48.65-11.63L172.8 12.09C168.6 4.625 160.6 0 152 0H24.01c-8.844 0-17.03 4.992-21.22 12.8C-1.4 20.59-.8741 29.94 4.032 37.31L99.07 179.9C110.2 168.1 122.4 157.5 135.9 148.5zM509.2 12.8C505 4.992 496.8 0 487.1 0h-127.1c-8.625 0-16.56 4.625-20.84 12.09l-57.99 101.5c16.91 1.961 33.16 5.992 48.65 11.63L373.9 48h69.22l-67.01 100.5c13.45 9.02 25.7 19.63 36.78 31.36l95.04-142.6C512.9 29.94 513.4 20.59 509.2 12.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMedal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;